import {useNavigate, useParams} from "react-router-dom";
import Header from '../../components/Header.jsx';
import {Button, Divider, Link} from "@heroui/react";
import {twMerge} from 'tailwind-merge';
import MyAccount from './MyAccount.jsx';
import Plans from './Plans.jsx';
import {useRecoilState} from 'recoil';
import {userState} from '../../store.jsx';
import {clearSessionData} from '../../helpers/AppHelper.jsx';

export default function UserBase({children}) {
	const {pageName} = useParams();
	const navigate = useNavigate();
	const [authMe] = useRecoilState(userState);
	return (
		<div className="">
			<Header
				className="border-b border-white"
			/>
			<div className="max-w-[1920px] mr-auto ml-0">
				<div className="grid grid-cols-12 gap-10 justify-start">
					<div className="col-span-3 hidden">
						<div className="bg-white p-4 rounded-30">
							<div className="pl-4">
								<h3 className="opacity-60 font-sans">Settings</h3>
							</div>
							
							<div className="mt-6 flex flex-col gap-2">
								<Button
									variant="bordered"
									as={Link}
									href="/user/profile"
									className={twMerge(["w-full justify-start min-h-12 !scale-100 border-0 font-sans", pageName === 'profile' && 'text-primary'])}
									startContent={<i className="hgi-stroke hgi-user text-xl"/>}
								>
									My Account
								</Button>
								<Button
									variant="bordered"
									as={Link}
									href="/user/plans"
									className={twMerge(["w-full justify-start min-h-12 !scale-100 border-0 font-sans", pageName === 'plans' && 'text-primary'])}
									startContent={<i className="hgi-stroke hgi-calendar-03 text-xl"/>}
								>
									Plans
								</Button>
								<Divider className="my-2"/>
								<Button
									onPress={() => {
										clearSessionData();
										navigate('/login');
									}}
									color="danger" variant="bordered"
									className="w-full justify-start min-h-12 !scale-100 border-0 font-sans"
									startContent={<i className="hgi-stroke hgi-login-circle-02 text-xl"/>}
								>
									Logout
								</Button>
							</div>
						</div>
					</div>
					<div className="col-span-12">
						<div
							className="bg-white py-6 px-6 rounded-30 relative w-full overflow-hidden">
							{pageName === 'profile' && <MyAccount/>}
							{pageName === 'plans' && <Plans/>}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
